{
  "about": {
    "imprint": "about.imprint",
    "partner": "about.partner",
    "privacy": "about.privacy",
    "tos": "about.tos"
  },
  "acl": {
    "not-omni": "Leider haben Sie mit ihrem aktuellen Benutzer keinen Zugriff auf den Administrationsbereich. Dieser ist derzeit ausschließlich einem Omni-Admin vorbehalten."
  },
  "app": {
    "about": "app.about",
    "title": "app.title"
  },
  "applications": {
    "accessGrantedOrganizations": "Zugangsberechtigte Organisationen",
    "accessGrantedProfiles": "Zugangsberechtigte Profile",
    "addLicensedOrganization": "Lizenz für Organisation hinzufügen:",
    "clientId": "ClientId",
    "create": "Erstellen",
    "edit": "Bearbeiten",
    "licensedOrganization": {
      "notAfter": "Lizenziert bis",
      "notBefore": "Lizenziert ab"
    },
    "licensedOrganizations": "Lizenzierte Organisationen",
    "licensedOrganizationsCount": "Anzahl lizenzierter Organisationen",
    "name": "Name",
    "uri": "URL"
  },
  "auth": {
    "change-profile": "oder Profil wechseln zu",
    "login": "Anmelden",
    "logout": "Abmelden",
    "other-account": "Mit anderem Account anmelden"
  },
  "authClients": {
    "clientId": "ClientId",
    "clientName": "Client Name",
    "clientSecret": "Client Secret",
    "create": "Erstellen",
    "edit": "Bearbeiten",
    "grantTypes": "Grant Types",
    "postLogoutRedirectUris": "Post logout redirect uris",
    "redirectUris": "Redirect uris",
    "responseTypes": "Response types",
    "scope": "Scope",
    "tokenEndpointAuthMethod": "Token endpoint auth method"
  },
  "BP aktivieren": "BP aktivieren",
  "BP deaktivieren": "BP deaktivieren",
  "change password": "Passwort aktualisieren",
  "common": {
    "about": "Über",
    "add": "{{type}} hinzufügen",
    "app-about": "Zentrale Administration, Verwaltung von Zugängen und Berechtigungen",
    "app-title": "Zentrale Administration",
    "cancel": "Abbrechen",
    "confirm": "common.confirm",
    "dbErrorToastText": "common.dbErrorToastText",
    "delete": "Löschen",
    "deleteType": "{{type}} löschen",
    "disconnect": "",
    "errorToastText": "common.errorToastText",
    "save": "Speichern",
    "select": {
      "organization": "Organisation auswählen"
    },
    "successCreateToastText_one": "common.successCreateToastText",
    "successCreateToastText_other": "common.successCreateToastText",
    "successDeleteToastText_one": "common.successDeleteToastText",
    "successDeleteToastText_other": "common.successDeleteToastText",
    "successDuplicateToastText_one": "common.successDuplicateToastText",
    "successDuplicateToastText_other": "common.successDuplicateToastText",
    "successSaveToastText_one": "common.successSaveToastText",
    "successSaveToastText_other": "common.successSaveToastText",
    "successToastText": "common.successToastText",
    "successUpdateToastText_one": "common.successUpdateToastText",
    "successUpdateToastText_other": "common.successUpdateToastText"
  },
  "dashboard": {
    "title": "Dashboard"
  },
  "delete": {
    "abort": "Abbrechen",
    "confirm": "delete.confirm",
    "confirmText": "Sind Sie sicher?",
    "title": "Löschen"
  },
  "federatedClients": {
    "clientId": "federatedClients.clientId",
    "clientSecret": "federatedClients.clientSecret",
    "issuer": "federatedClients.issuer",
    "responseTypes": "federatedClients.responseTypes"
  },
  "form": {
    "submit": "Absenden",
    "submitting": "Unterwegs"
  },
  "groups": {
    "edit": "Gruppe bearbeiten",
    "editUsers": "Mitglieder bearbeiten",
    "title": "Gruppen"
  },
  "IPHIS aktivieren": "IPHIS aktivieren",
  "IPHIS deaktivieren": "IPHIS deaktivieren",
  "not-implemented": "Diese Funktion ist leider noch nicht implementiert",
  "organizations": {
    "title": "Organisationen"
  },
  "organizationSelect": {
    "placeholder": "Organization wählen"
  },
  "pageNotFound": {
    "title": "Die Seite konnte nicht gefunden werden"
  },
  "password": {
    "confirmNewPasswordLabel": "Passwort wiederholen",
    "newPasswordLabel": "Neues Passwort (mindestens 6 Zeichen)",
    "oldPasswordLabel": "Aktelle Passwort",
    "required": "password.required",
    "tooShort": "password.tooShort"
  },
  "planung": {
    "app": "Vertretungsplan-App",
    "enabled": "Planung Aktiviert",
    "solver": "Generator",
    "substitution": "Vertretungsplan",
    "teachingload": "Deputate",
    "timetable": "Stundenplan"
  },
  "Planung aktivieren": "Planung aktivieren",
  "Planung deaktivieren": "Planung deaktivieren",
  "products": {
    "planung": "TK-Planung"
  },
  "profiles": {
    "create": "Profil erstellen",
    "edit": "Profil bearbeiten",
    "onDeleteConfirmText": "onDeleteConfirmText",
    "roles": {
      "groups": {
        "add": "Rollen für Gruppe hinzufügen",
        "relation": "Bedingung"
      },
      "profiles": {
        "add": "Beziehung zu Profil hinzufügen",
        "relation": "Bedingung"
      }
    }
  },
  "properties": {
    "add": "Eigenschaften hinzufügen",
    "title": "Properties"
  },
  "propertyName": "Name",
  "propertyScope": "Scope",
  "propertyValue": "Wert",
  "require": {
    "backend": {
      "offline": "Leider ist das Backend aktuell offline - bitte Versuchen Sie es in kürze erneut!",
      "version": "Leider ist das Backend veraltet!"
    },
    "retry": "Erneut versuchen"
  },
  "roles": {
    "title": "Rollen",
    "type": "Typ"
  },
  "settings": {
    "title": "Einstellungen"
  },
  "shadow": {
    "and": "Und",
    "conditions": {
      "select": "Bedingung"
    },
    "optIn": "optIn",
    "or": "Oder",
    "profiles": {
      "add-organization": "Profile in Organization spiegeln:"
    },
    "remove": "",
    "shadowProfilesFrom": "{{organization}} spiegelt Profile nach",
    "shadowProfilesTo": "Spiegelt Profile nach {{organization}}"
  },
  "users": {
    "inviteEmailSendSuccessToastText": "Einladung erfolgreich versendet",
    "title": "Benutzerkonten"
  },
  "VPO aktivieren": "VPO aktivieren",
  "VPO deaktivieren": "VPO deaktivieren"
}
